import React, { useState } from 'react'

import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { InputText } from 'primereact/inputtext'
import { Button } from 'primereact/button'
import { Toolbar } from 'primereact/toolbar'
import { Modal } from 'antd'

import { getMessage } from '../../util/IntlMessages'
import CreateAlternative from './CreateAlternative/CreateAlternative'

const Header = ({ globalFilterValue, onGlobalFilterChange, exportCSV, exportExcelData, updateAlternativeList }) => {
  const [modalDocumentVisible, setModalDocumentVisible] = useState(false)
  return (
    <Toolbar
      start={
        <React.Fragment>
          <div>
            <row>
              <h2>
                <b>Lista de Alternativos</b>
              </h2>
            </row>
          </div>
        </React.Fragment>
      }
      end={
        <React.Fragment>
          <div style={{ display: 'flex' }}>
            <IconField iconPosition="left">
              <InputIcon className="pi pi-search"> </InputIcon>
              <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Pesquisar" />
            </IconField>
            <Button
              style={{ marginLeft: '10px' }}
              type="button"
              className="p-button-success mr-2"
              icon="pi pi-file"
              rounded
              onClick={() => exportCSV(false)}
              data-pr-tooltip="CSV"
            />
            <Button
              type="button"
              className="p-button-success mr-2"
              icon="pi pi-file-excel"
              severity="success"
              rounded
              onClick={exportExcelData}
              data-pr-tooltip="XLS"
            />
            <Button icon="pi pi-plus" onClick={() => setModalDocumentVisible(true)} />
          </div>
          <Modal
            destroyOnClose={() => {
              setModalDocumentVisible(false)
            }}
            onCancel={() => {
              setModalDocumentVisible(false)
            }}
            title={getMessage('createAlternate')}
            footer={null}
            width="70%"
            visible={modalDocumentVisible}
          >
            <CreateAlternative
              alternativeId={null}
              onCancel={() => {
                setModalDocumentVisible(false)
              }}
              updateAlternativeList={updateAlternativeList}
            />
          </Modal>
        </React.Fragment>
      }
    />
  )
}

export default Header
